export default "__VITE_ASSET__ChOt5yA$__"